module.exports = __webpack_public_path__ + "54cf98f5/img/rename-icon.de4e673d.svg";